import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Constants} from '../../common/constants';
import {FieldConfigName} from '../../../models';
import {ControlDialogOptionsHelper} from '../control-dialog-options-helper';

@Component({
  selector: 'app-text-input-dialog',
  templateUrl: './text-input-dialog.component.html'
})
export class TextInputDialogComponent extends ControlDialogOptionsHelper implements OnInit {
  constants: any = Constants;
  editTextInputForm: UntypedFormGroup;
  control: FieldConfigName;
  minLengthLabel: number;
  maxLengthLabel: number;

  constructor(private formBuilder: UntypedFormBuilder,
              public dialogRef: MatDialogRef<TextInputDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    if (data) {
      this.control = data.control || this.control;
    }
  }

  ngOnInit(): void {
    this._initForm();
    this._initFormValues(this.control);
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.editTextInputForm.invalid) {
      return;
    }
    this.dialogRef.close(this.editTextInputForm.value);
  }
  private _initForm(): void {
    this.editTextInputForm = this.formBuilder.group({
      tooltip: ['', []],
      label: ['', []],
      placeholder: ['', []],
      isRequired: [false]
    });
  }
  private _initFormValues(control: any): void {
    this.editTextInputForm.setValue({
      tooltip: control.options.tooltip,
      label: control.options.label,
      placeholder: control.options.placeholder,
      isRequired: control.options.isRequired
    });
  }
}
